import { IconNameV1, IconV1 } from 'common/icon/iconV1.js';
import { IconName } from 'common/pill/types.js';
import { IWarning } from 'redux-state/weather-warnings/types.js';
import { iconForCondition } from 'types/condition.js';
import { IMarker } from 'types/markerCore/marker-core-type.js';
import { getMarkerWarningsLoc } from 'types/markerTypes/markers.warning.js';
import { ILocationSummary } from 'types/markerTypesV1/marker-v1-view-type.js';
import { getFirstOfArr, predicateMarkerV1 } from 'utilities/isType.js';
import { getSeverityInfo } from 'utilities/weather-warnings/warning-severity.js';

export const getHTMLWarningIconsPartial = <T extends IconName>({
  warnings = [],
}: {
  warnings?: IWarning[];
}): Set<T> => {
  const result = new Set([
    ...warnings.map(({ warnLevel, icon }) => {
      const warningInfo = getSeverityInfo(warnLevel);
      const iconName = `${icon}-${warningInfo.iconColor}` as T;
      return iconName;
    }),
  ]);
  return result;
};

const HTMLConditionIcon = ({
  value,
  iconClasses,
  key,
}: {
  value: ILocationSummary['value'];
  iconClasses?: string;
  key: string;
}) => {
  if ('condition' in value && value.condition) {
    const iconName = iconForCondition(value.condition) as IconNameV1;
    return <IconV1 icon={iconName} key={`${iconName}-${key}`} iconClass={iconClasses} />;
  }
  return null;
};

export const getHTMLMarkerIcons = ({ marker, warnings }: { marker?: IMarker; warnings?: IWarning[] }) => {
  if (marker) {
    if (predicateMarkerV1(marker)) {
      const subject = getFirstOfArr(marker.subject);
      if (subject) {
        const { value } = subject;
        const key = subject.key;
        const icons = [];

        const warningArr = warnings ?? getMarkerWarningsLoc(subject);

        const warningsIcons = Array.from(getHTMLWarningIconsPartial<IconNameV1>({ warnings: warningArr }));
        if (warningsIcons) {
          icons.push(warningsIcons.map((iconName) => <IconV1 icon={iconName} key={`${iconName}-${key}`} />));
        }
        // Handle urban condition icons
        const conditionIcon = HTMLConditionIcon({ value, key });
        if (conditionIcon) {
          icons.push(conditionIcon);
        }
        return icons;
      }
      return undefined;
    }
  }
};
